import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <>
      <div className="footer">
        Margarida Sousa @ DevChallenges.io
      </div>
    </>
  );
}
 
export default Footer;